import { Card, Skeleton, Stack } from "@mui/material";
import React from "react";

export default function ActivitySkeleton() {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        p: 1,
        maxWidth: "sm",
        mb: 2,
      }}
    >
      <Skeleton
        sx={{
          width: { xs: "80px", sm: "120px" },
          height: { xs: "120px", sm: "180px" },
          borderRadius: 1,
        }}
        variant="rectangle"
      />
      <Stack direction="column" spacing={1} sx={{ flexGrow: 1, pl: 2 }}>
        <Skeleton width="70%" />
        <Skeleton width="60%" />
        <Skeleton width="50%" />
      </Stack>
    </Card>
  );
}
